import { render } from "./MainObjectives.vue?vue&type=template&id=1a59117a"
import script from "./MainObjectives.vue?vue&type=script&lang=js"
export * from "./MainObjectives.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__